import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';

/** Closes the mobile screen on the device back button. */
export function useInterceptBackButton() {
  const blocker = useBlocker(({ historyAction }) => historyAction === 'POP');

  useEffect(() => {
    if (blocker.state !== 'blocked') return;

    blocker.reset();
    MobileAppBridge.closeScreen();
  }, [blocker]);
}
